import React, { useRef, useState, useLayoutEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Groupbox } from 'components/Form';
import { descendingComparator, stableSort } from 'utils/sortable';
import SpecifiersDropdown from './SpecifiersDropdown';
import SpecifiersList from './SpecifiersList';
import MultiselectList from './MultiselectList';

const useStyles = makeStyles((theme) => ({
  refineLabel: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '18px',
  },
  refiners: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '16px',
    letterSpacing: '0.15px',
    lineHeight: '21px',
  },
  primary: { fontSize: '14px', lineHeight: '20px' },
  root: { paddingTop: '4px', paddingBottom: '4px' },
}));

const SpecifierTypeComponentMap = {
  dropdown: SpecifiersDropdown,
  list: SpecifiersList,
  multiselect: MultiselectList,
};

const ProductsRefiners = (props) => {
  const sortByValues = (specifiers, currentSpecifier) => {
    const item = props.refinersValues.find((v) => v.specifier === currentSpecifier);
    if (item) {
      specifiers[currentSpecifier] = stableSort(specifiers[currentSpecifier], (a, b) => {
        return -descendingComparator(
          item.values.find((v) => v.name === a),
          item.values.find((v) => v.name === b),
          'index',
        );
      });
    }
  };

  const getAvailableSpecifiers = () => {
    const res = {};
    products
      .filter((p) => !!p.specifications)
      .forEach((p) => {
        Object.keys(p.specifications).forEach((k) => {
          if (!res[k]) {
            res[k] = [];
          }

          const v = p.specifications[k];

          if (Array.isArray(v)) {
            res[k] = [...new Set([...res[k], ...v.map((e) => String(e))])];
          } else {
            res[k] = [...new Set([...res[k], String(v)])];
          }

          sortByValues(res, k);
        });
      });
    return res;
  };

  const { refiners, schema, products } = props;
  //const { qualifiers } = refiners;
  const qualifiers = refiners?.qualifiers || [];
  const availableSpecifiers = getAvailableSpecifiers();
  const specifiersKeyList = Object.keys(availableSpecifiers);
  const specifierList = specifiersKeyList
    .map((k) => schema.specifiers.find((s) => s.name === k))
    .sort((a, b) => (a.type < b.type ? 1 : -1))
    .filter((s) => !!s);

  const classes = useStyles();

  const targetRef = useRef();
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (targetRef.current) {
      setHeight(window.innerHeight - targetRef.current.offsetTop - 50);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef.current?.offsetHeight]);

  return (
    <div ref={targetRef}>
      <Groupbox style={{ height, overflowY: 'auto', overflowX: 'hide' }}>
        <span className={classes.refiners}>Refiners:</span>
        <List component="nav" aria-label="secondary mailbox folder">
          {qualifiers
            .map((q) => schema.qualifiers.find((s) => s.route === q))
            //.filter(q => !!q && products.find(p => p.qualifier === q.route))
            .filter(
              (q) =>
                !!q &&
                products.find((p) =>
                  Array.isArray(p.qualifier)
                    ? p.qualifier.includes(q.route)
                    : p.qualifier === q.route,
                ),
            )
            .map((q) => (
              <ListItem
                button
                classes={{ root: classes.root }}
                selected={props.values.qualifier === q.route}
                key={q.route}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: 'qualifier',
                      value: props.values.qualifier !== q.route ? q.route : '',
                    },
                  });
                  props.submitForm();
                }}
              >
                <ListItemText classes={{ primary: classes.primary }} primary={q.label} />
              </ListItem>
            ))}
        </List>
        <span className={classes.refineLabel}>{`Refine ${schema.label}`}</span>
        {specifierList.map((s) => {
          const Component = SpecifierTypeComponentMap[s.type];
          return (
            <div key={s.name}>
              {Component ? (
                <Component {...props} schema={s} specifiers={availableSpecifiers} />
              ) : null}
            </div>
          );
        })}
      </Groupbox>
    </div>
  );
};

export default ProductsRefiners;
